const userList = [
  {
    userName: "john.smith@zurichna.com",
    userId: 3,
    loginTime: "2022-11-21T10:49:58.088+00:00",
    roles: ["USER"],
    phoneNum: "+15852826892",
    email: "john.smith@zurichna.com",
    currentRoleType: "USER",
    firstName: "John",
    lastName: "Smith",
    password: "John@2023",
  },
  {
    userName: "admin.smith@zurichna.com",
    userId: 3,
    loginTime: "2022-11-21T10:49:58.088+00:00",
    roles: ["Admin"],
    phoneNum: "+15852826892",
    email: "admin.smith@zurichna.com",
    currentRoleType: "ADMIN",
    firstName: "John",
    lastName: "Smith",
    password: "John@2023",
  },
];

export default userList;
